<template>
  <div class="autocomplete-popup__on-focus-container q-row">
    <div v-if="showQueriesSection" class="on-focus__queries-list q-col-lg-3">
      <UserRecentQueriesContainer v-if="recentQueriesEnabled"/>
      <PopularQueriesContainer v-if="popularQueriesEnabled"/>
      <PredefinedQueriesContainer v-if="showPredefinedQueries" :sections="sections"/>
    </div>
    <PopularProductsContainer/>
  </div>
</template>
<script setup lang="ts">
import PredefinedQueriesContainer from './PredefinedQueries/PredefinedQueriesContainer.vue'
import UserRecentQueriesContainer from './UserRecentQueries/UserRecentQueriesContainer.vue'
import PopularQueriesContainer from './PopularQueries/PopularQueriesContainer.vue'

import {inject} from "vue";
import PopularProductsContainer
  from "@/components/AutocompletePopup/OnFocus/PopularProducts/PopularProductsContainer.vue";


const SmartSearchConfig = inject('SmartSearchConfig').value;

const popularQueriesEnabled = SmartSearchConfig?.onfocus?.popularQueries?.enabled

const {enabled, sections} = SmartSearchConfig?.onfocus?.predefinedQueries
const showPredefinedQueries = sections.length > 0 && enabled

const recentQueriesEnabled = SmartSearchConfig?.onfocus?.recentQueries?.enabled
const showQueriesSection = popularQueriesEnabled || showPredefinedQueries || recentQueriesEnabled


</script>
